// components/TaskAnalysisChart.js
import { Bar } from 'vue-chartjs'

export default {
  extends: Bar,
  props: ['chartData'],
  data () {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: { position: 'top' },
        scales: {
          yAxes: [
            {
              id: 'y-axis-avg',
              type: 'linear',
              position: 'right',
              ticks: { beginAtZero: true },
              scaleLabel: { display: true, labelString: 'เวลาเฉลี่ย (นาที)' },
              gridLines: { drawOnChartArea: false } // ซ่อนเส้นตารางไม่ให้ทับกับแกนซ้าย
            },
            {
              id: 'y-axis-count',
              type: 'linear',
              position: 'left',
              ticks: { beginAtZero: true },
              scaleLabel: { display: true, labelString: 'จำนวนงาน (ครั้ง)' }
            }
          ]
        }
      }
    }
  },
  mounted () {
    this.renderChart(this.chartData, this.options)
  },
  watch: {
    chartData: {
      handler (newData) {
        // ทำลายกราฟเก่าก่อนวาดใหม่เมื่อข้อมูลเปลี่ยน
        if (this.$data._chart) {
          this.$data._chart.destroy()
        }
        this.renderChart(newData, this.options)
      },
      deep: true
    }
  }
}
